import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {SwalAlertClass} from "core/swalClass";
import axiApi from "../../ApiCaller";

const TableRoutes = () => {
    const {t: _tT} = useTranslation("tables");
    const {t: _tC} = useTranslation("choices");
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [routes, setRoutes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axiApi
            .get(`/api/home/routes/`)
            .then((resp) => {
                setRoutes(resp.data);
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);
    // console.log("routes", routes);
    return (
        <>
            {loading ? (
                <div className="text-center p-3">Cargando rutas...</div>
            ) : (
                <div>
                    <table className="table table-striped">
                        <thead className="table-light">
                            <tr>
                                <th>{_tT("common.name")}</th>
                                <th>{_tT("common.type")}</th>
                                <th>{_tT("common.waste")}</th>
                                <th>{_tT("common.download")}</th>
                                <th>{_tT("routes.actives")}</th>
                                <th>{_tT("routes.medium-fill")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {routes.length > 0 ? (
                                routes.map((route, index) => (
                                    <tr key={index}>
                                        <td>{route.name}</td>
                                        <td>
                                            {_tC(
                                                `route_types.${route.type
                                                    .toLowerCase()
                                                    .charAt(0)}`
                                            )}
                                        </td>
                                        <td>
                                            {_tC(`wastes.${route.waste_type}`)}
                                        </td>
                                        <td>
                                            {_tC(
                                                `downloads.${route.download_type}`
                                            )}
                                        </td>
                                        <td>{route.container_count}</td>
                                        <td>
                                            {route.avg_filling
                                                ? `${route.avg_filling}%`
                                                : "-"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        No hay rutas disponibles
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

export default TableRoutes;
